import { authHttp } from '../http'
import * as deliveryRoutes from '../../routes/deliveries.routes'
import * as pickingRoutes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'

export async function importDeliveries(ciclo_id, info, file_type_id) {
  try {
    const response = await authHttp().post(
      deliveryRoutes.urlPostImportacaoInfo(ciclo_id, file_type_id),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function importDeliveriesMultiCicle(info, file_type_id, user_id) {
  try {
    const response = await authHttp().post(
      deliveryRoutes.urlPostImportacaoMultiCicle(user_id, file_type_id),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function importAssocAreaExcel(picking_id, info, tipoArquivoId) {
  try {
    const url =
      tipoArquivoId === 7
        ? pickingRoutes.urlPostImportacaoAssocAreaExcelTipoArquivo7(picking_id, tipoArquivoId)
        : pickingRoutes.urlPostImportacaoAssocAreaExcel(picking_id, tipoArquivoId)

    const response = await authHttp().post(url, info)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCicloInfo(cicloId) {
  try {
    const response = await authHttp().get(deliveryRoutes.urlGetCicloInfo(cicloId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPlacasPrevistaCarregamentoByPickingId(pickingId) {
  try {
    const url = pickingRoutes.urlPlacasPrevistaCarregamentoByPickingId(pickingId)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function definirAssocAreasAhPartirOrdemCarregamento(
  placasWithOrdemCarregamento,
  pickingId,
  addBadgeToAreaNickname,
  addInfoComplementarToAreaNickname,
) {
  try {
    const url = pickingRoutes.urlAssocAreasAhPartirOrdemCarregamento(
      addBadgeToAreaNickname,
      addInfoComplementarToAreaNickname,
    )
    await authHttp().put(url, {
      placas_ordem_carregamento: placasWithOrdemCarregamento,
      picking_id: pickingId,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}
